export default __webpack_public_path__ + "static/media/ic_menu.6d77cbcf.svg";